module.exports = __webpack_public_path__ + "img/mini_logo.433a7557.svg";